<div class="sync-update-container">
  <button class="check-update-sync" (click)="toggleTable()">
    <img src="assets/images/reordering.svg" alt="Check Sync" />
  </button>
  <div class="custom-model-table" *ngIf="isTableVisible">
    <div class="d-flex justify-content-between align-items-center">
      <h5 class="mb-0">Spark Sync Reordering</h5>
      <button mat-icon-button (click)="toggleTable()" aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="table-data-container">
      <app-gis-data-table
        [data]="selectedData"
        [columns]="displayColumn"
        [enableDragDrop]="true"
        (dragDropped)="onDrop($event)">
      </app-gis-data-table>
    </div>
  </div>
</div>